"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EGender = void 0;
exports.EGender = {
    homme: "homme",
    femme: "femme",
    autre: "autre",
};
